import i18n from "@/i18n"
import { Driver } from "@/types"
import { DriverUtils } from "@/utils"

import { DriversTableHeader } from "./DriversListView"

export function sortDriversListColumn(column: DriversTableHeader | null, isSortedDesc: boolean) {
  const returnValue = isSortedDesc ? -1 : 1

  switch (column) {
    case null:
    case "ordinal":
    case "blocks":
      return () => 0

    case "name":
      return () => (a: Driver, b: Driver) => {
        return a.name.localeCompare(b.name, "pl") * returnValue
      }

    case "team_name":
      return () => (a: Driver, b: Driver) => {
        return a.team.name.localeCompare(b.team.name, "pl") * returnValue
      }

    case "email":
      return () => (a: Driver, b: Driver) => {
        return a.email.localeCompare(b.email, "pl") * returnValue
      }

    case "phone":
      return () => (a: Driver, b: Driver) => {
        return String(a.phone).localeCompare(String(b.phone), "pl") * returnValue
      }

    case "status":
      return () => (a: Driver, b: Driver) => {
        return a.state.localeCompare(b.state, "pl") * returnValue
      }

    case "payment_collection_system":
      return () => (a: Driver, b: Driver) => {
        const valueA = a.payment_collection_system || ""
        const valueB = b.payment_collection_system || ""

        if (!valueA) return 1
        if (!valueB) return -1

        return valueA.localeCompare(valueB, "pl") * returnValue
      }

    case "disabled_payment_forms":
      return () => (a: Driver, b: Driver) => {
        return (
          (a.payment_forms.filter((form) => !!form && form !== "paid").length <
          b.payment_forms.filter((form) => !!form && form !== "paid").length
            ? -1
            : 1) * returnValue
        )
      }

    case "working_hours":
      return () => (a: Driver, b: Driver) => {
        const valueA = DriverUtils.getCurrentWorkingHours(a)
        const valueB = DriverUtils.getCurrentWorkingHours(b)

        if (!valueA) return 1
        if (!valueB) return -1

        return valueA.localeCompare(valueB, "pl") * returnValue
      }

    case "unsettled_orders_count":
      return () => (a: Driver, b: Driver) =>
        (a.unsettled_orders_count! > b.unsettled_orders_count! ? -1 : 1) * returnValue // Assume it will be non-null for now. Buggy key!

    case "device":
      return () => (a: Driver, b: Driver) => {
        const valueA = DriverUtils.getSystem(a.drivers_app_version) || ""
        const valueB = DriverUtils.getSystem(b.drivers_app_version) || ""

        if (!valueA) return 1
        if (!valueB) return -1

        return valueA.localeCompare(valueB, "pl") * returnValue
      }

    case "transport":
      return () => (a: Driver, b: Driver) => {
        const valueA = i18n.t(`drivers:${a.transport_type}`)
        const valueB = i18n.t(`drivers:${b.transport_type}`)

        return valueA.localeCompare(valueB, "pl") * returnValue
      }
  }
}
